import React, { useState } from 'react';
import { useHistory } from '@magento/venia-drivers';
import classes from './mobileHeader.css';
import burger_icon from '@magento/venia-ui/venia-static/icons/burger.svg';
import location_icon from '@magento/venia-ui/venia-static/icons/location.svg';
import stokes_logo from '@magento/venia-ui/venia-static/icons/stokesmobile.svg';
import close_icon from '@magento/venia-ui/venia-static/icons/closeicon.svg';
import SearchBar from '../SearchBar';
import StoreSchedule from './storeSchedule';
import MyAccountMenu from './myAccountMenu';
import ThinkKitchen from '@magento/venia-ui/venia-static/icons/thinkkitchen.svg';
import CartTrigger from './cartTrigger';
import { useAppContext } from "@magento/peregrine/lib/context/app";
import Autocomplete from '../Category/autocomplete';
import { useScrollLock } from "@magento/peregrine";
import UpperHeaderShippingMessage from "./components/upperHeaderShippingMessage";
var MobileHeader = props => {
  var {
    navbar,
    getFormattedHeaderData,
    isPrerender,
    menuData
  } = props;
  var history = useHistory();
  var menuHeaderData = getFormattedHeaderData();
  var [{
    openStoreModal,
    currentStore,
    searchBarValue
  }, {
    setOpenStoreModal
  }] = useAppContext();
  var [accountMenu, setAccountMenu] = useState(!isPrerender && 'init');
  var [schedule, setSchedule] = useState(!isPrerender && 'init');
  var [accountMode, setAccountMode] = useState(false);
  useScrollLock(accountMenu === "openAccountMenu");
  return /*#__PURE__*/React.createElement("div", {
    className: classes.mobileHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.relativeStickyAnchorContainer
  }, navbar && /*#__PURE__*/React.createElement("div", {
    className: classes.upperHeader
  }, /*#__PURE__*/React.createElement(UpperHeaderShippingMessage, null)), /*#__PURE__*/React.createElement("div", {
    className: classes.mobileMiddleHeader
  }, accountMenu === 'openAccountMenu' ? /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      setAccountMenu('closeAccountMenu');
    },
    className: classes.accountMenuButton
  }, /*#__PURE__*/React.createElement("img", {
    src: close_icon,
    alt: 'closeIcon'
  })) : /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      if (schedule !== 'closeSchedule') {
        setSchedule('closeSchedule');
      }
      setAccountMenu('openAccountMenu');
      setOpenStoreModal(false);
    },
    className: classes.accountMenuButton
  }, /*#__PURE__*/React.createElement("img", {
    src: burger_icon,
    alt: 'burgerIcon'
  })), /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      if (schedule !== 'closeSchedule') {
        setSchedule('closeSchedule');
      }
      history.push('/');
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: stokes_logo,
    alt: 'stokesLogo'
  }), /*#__PURE__*/React.createElement("img", {
    src: ThinkKitchen,
    alt: 'logo'
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.middleActionsContainer
  }, /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      if (accountMenu !== 'init') {
        setAccountMenu('init');
      }
      if (openStoreModal) {
        setSchedule('init');
        setOpenStoreModal(!openStoreModal);
      } else {
        setSchedule(schedule === 'openSchedule' ? 'closeSchedule' : 'openSchedule');
      }
    },
    className: classes.accountMenuButton,
    style: {
      marginRight: '1rem'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: location_icon,
    alt: 'locationIcon'
  })), /*#__PURE__*/React.createElement(CartTrigger, {
    setSchedule: setSchedule,
    schedule: schedule
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.mobileSearch
  }, /*#__PURE__*/React.createElement(SearchBar, null), schedule !== 'init' && /*#__PURE__*/React.createElement(StoreSchedule, {
    setSchedule: setSchedule,
    schedule: schedule,
    currentStore: currentStore
  }), accountMenu !== 'init' && /*#__PURE__*/React.createElement(MyAccountMenu, {
    accountMenu: accountMenu,
    setAccountMenu: setAccountMenu,
    menuHeaderData: menuHeaderData,
    accountMode: accountMode,
    setAccountMode: setAccountMode,
    isPrerender: isPrerender,
    menuData: menuData
  })), searchBarValue && /*#__PURE__*/React.createElement(Autocomplete, null)));
};
export default MobileHeader;